import * as React from 'react';

const NoteFilledSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g
            id="note-filled_svg__note-filled"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        >
            <path d="M21.992 18v4l-4.434-4H2V2h20v16h-.008zM8.001 9.5v1H11.5V14h.996v-3.5h3.508v-1h-3.508V6H11.5v3.5H8z" />
        </g>
    </svg>
);

NoteFilledSvg.displayName = 'NoteFilledSvg';
export default NoteFilledSvg;
